export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const UPDATE_USER_DATA_SUCCESS = "UPDATE_USER_DATA_SUCCESS";
export const UPDATE_USER_DATA_FAILED = "UPDATE_USER_DATA_FAILED";

export function updateUserData(payload) {
  return {
    type: UPDATE_USER_DATA,
    payload,
  };
}

export function updateUserDataSuccess(payload) {
  return {
    type: UPDATE_USER_DATA_SUCCESS,
    payload: payload,
  };
}

export function updateUserDataFail(payload) {
  return {
    type: UPDATE_USER_DATA_FAILED,
    payload: payload,
  };
}
